//get earnings
export const GET_BROADCAST_EARNINGS_REQUEST = "GET_BROADCAST_EARNINGS_REQUEST";
export const GET_BROADCAST_EARNINGS_RECEIVE = "GET_BROADCAST_EARNINGS_RECEIVE";
export const GET_BROADCAST_EARNINGS_FAILURE = "GET_BROADCAST_EARNINGS_FAILURE";
export const RESET_GET_BROADCAST_EARNINGS= "RESET_GET_BROADCAST_EARNINGS";